import { defineComponent as _defineComponent } from 'vue'
import { Ref, ref } from 'vue';
import { TncDialog } from '@tencent/wphk-act-base-ui';
import { useGlobalBi } from '@/hooks/use-global-bi';

// ---- props ----

export default /*#__PURE__*/_defineComponent({
  __name: 'footer',
  props: {
  tncUrl: String,
},
  setup(__props) {



// ---- ref句柄 ----
const refTncDialog: Ref<InstanceType<typeof TncDialog> | null> = ref(null);

// ---- hooks ----
const { getBiExt } = useGlobalBi();

// 点击条款与细则
function handleViewRule() {
  refTncDialog.value?.showTncDialog();
}

return { __sfc: true,refTncDialog, getBiExt, handleViewRule, TncDialog }
}

})